export const SERVICE = 'INVITATIONS'

export const PAGE_LIMIT = 10
